import axios from 'axios'

const _token = (new URL(window.location.href)).searchParams.get('t')
let _api = null
let _uploadApi = null
let _downloadApi = null

const getApi = (api, headers, responseType = 'json') => {
  if (!api) {
    if (_token) {
      headers['X-Accounting-Token'] = _token
    }
    api = axios.create({
      baseURL: '/api/v1',
      withCredentials: false,
      headers: headers,
      responseType: responseType
    })
  }
  let csrftoken = window.$cookies.get('csrftoken')
  if (csrftoken) {
    api.defaults.headers.common['X-CSRFToken'] = csrftoken
  }
  return api
}

const Api = () => {
  return getApi(_api, {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  })
}

const UploadApi = () => {
  return getApi(_uploadApi, {
    'Content-Type': 'multipart/form-data'
  })
}

const DownloadApi = () => {
  return getApi(_downloadApi, {
    'Content-Type': 'application/json'
  })
}

export { getApi, Api, UploadApi, DownloadApi }
